
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_6zobj_93",
  "header": "awsui_header_l0dv0_6zobj_130",
  "header-link": "awsui_header-link_l0dv0_6zobj_141",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_6zobj_151",
  "header-link-text": "awsui_header-link-text_l0dv0_6zobj_151",
  "header-logo": "awsui_header-logo_l0dv0_6zobj_156",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_6zobj_162",
  "list-container": "awsui_list-container_l0dv0_6zobj_167",
  "list": "awsui_list_l0dv0_6zobj_167",
  "list-variant-root": "awsui_list-variant-root_l0dv0_6zobj_177",
  "list-variant-root--last": "awsui_list-variant-root--last_l0dv0_6zobj_181",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_6zobj_185",
  "list-item": "awsui_list-item_l0dv0_6zobj_189",
  "section": "awsui_section_l0dv0_6zobj_195",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_6zobj_196",
  "section--no-ident": "awsui_section--no-ident_l0dv0_6zobj_199",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_6zobj_200",
  "refresh": "awsui_refresh_l0dv0_6zobj_209",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_6zobj_217",
  "section-group": "awsui_section-group_l0dv0_6zobj_222",
  "section-group-title": "awsui_section-group-title_l0dv0_6zobj_232",
  "link": "awsui_link_l0dv0_6zobj_236",
  "link-active": "awsui_link-active_l0dv0_6zobj_245",
  "info": "awsui_info_l0dv0_6zobj_279",
  "external-icon": "awsui_external-icon_l0dv0_6zobj_283",
  "divider": "awsui_divider_l0dv0_6zobj_287",
  "divider-default": "awsui_divider-default_l0dv0_6zobj_292",
  "divider-header": "awsui_divider-header_l0dv0_6zobj_296"
};
  